import React, { useEffect, useRef, useState } from 'react';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { Button, Col, Input, Layout, Row, message, Form, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { setAuth, setAdmin } from '../redux/actions/common'
// import 'antd/dist/antd.css';
// import '@ant-design/compatible/assets/index.css';
import * as Service from '../core/Service';
import logo from '../assets/aba_taxi.png';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// import { getSelectionsSetting } from '../network/DataStore';

const Login = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();

  const [resetPwModalVisible, setResetPwModalVisible] = useState(false);
  const [turnstileSiteKey, setTurnstileSiteKey] = useState('');
  const [turnstileToken, setTurnstileToken] = useState('');
  const turnstileContainerRef = useRef(null);
  const turnstileWidgetIdRef = useRef(null);

  const resetTurnstile = () => {
    setTurnstileToken('');
    if (window.turnstile && turnstileWidgetIdRef.current !== null) {
      window.turnstile.reset(turnstileWidgetIdRef.current);
    }
  };

  useEffect(() => {
    const initTurnstileConfig = async () => {
      let configData = await Service.call('get', '/api/config');
      if (configData && configData.TURNSTILE_SITE_KEY) {
        setTurnstileSiteKey(configData.TURNSTILE_SITE_KEY);
      }
    };
    initTurnstileConfig();
  }, []);

  useEffect(() => {
    if (!turnstileSiteKey) {
      return;
    }

    const scriptId = 'turnstile-script';
    let turnstileScript = document.getElementById(scriptId);

    const renderTurnstile = () => {
      if (!window.turnstile || !turnstileContainerRef.current || turnstileWidgetIdRef.current !== null) {
        return;
      }

      turnstileWidgetIdRef.current = window.turnstile.render(turnstileContainerRef.current, {
        sitekey: turnstileSiteKey,
        callback: (token) => {
          setTurnstileToken(token);
        },
        'expired-callback': () => {
          setTurnstileToken('');
        },
        'error-callback': () => {
          setTurnstileToken('');
        },
      });
    };

    if (!turnstileScript) {
      turnstileScript = document.createElement('script');
      turnstileScript.id = scriptId;
      turnstileScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      turnstileScript.async = true;
      turnstileScript.defer = true;
      document.body.appendChild(turnstileScript);
    }

    turnstileScript.addEventListener('load', renderTurnstile);
    renderTurnstile();

    return () => {
      turnstileScript.removeEventListener('load', renderTurnstile);
    };
  }, [turnstileSiteKey]);


  const onFinish = async (formData) => {
    if (turnstileSiteKey && _.isEmpty(turnstileToken)) {
      return message.error(t('login.complete_verification'));
    }

    let { email, password } = formData;
    let data = await Service.call('post', `/api/login/admin`, {
      email,
      password,
      turnstileToken
    });
    if (!data || data.errorMessage) {
      resetTurnstile();
      return message.error(data ? data.errorMessage : t('login.login_fail'));
    }

    let adminData = await Service.call('get', `/api/admin`);
    if (!adminData || adminData.errorMessage) {
      resetTurnstile();
      return dispatch(setAuth(false));
    }
    if (_.isEmpty(adminData.userData)) {
      resetTurnstile();
      return dispatch(setAuth(false));
    }


    dispatch(setAdmin(adminData.userData[0]));
    dispatch(setAuth(true));

    // getSelectionsSetting();
    history.push('/trafficnews_list')
  }

  const displayLogin = () => {
    return (
      <div className="" style={{ display: 'flex', justifyContent: 'center' }}>
        <Form
          className="login-form col-12 mt-2"
          style={{ width: '100%' }}
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: t('login.input_email'), type: 'email' }]}
          >
            <Input
              prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={t("common.email")}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: t('login.input_password') }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={t('common.password')}
            />
          </Form.Item>
          {
            turnstileSiteKey ? (
              <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
                <div ref={turnstileContainerRef} />
              </div>
            ) : null
          }
          <Button
            style={{ width: "100%" }}
            type="primary"
            htmlType="submit"
            className="login-form-button"
            disabled={Boolean(turnstileSiteKey) && _.isEmpty(turnstileToken)}
          >
            {t('login.login')}
          </Button>

          <Button
            style={{ width: "100%", marginTop: 20 }}
            type="default"
            className="login-form-button"
            onClick={() => {
              setResetPwModalVisible(true);
            }}
          >
            {t('login.reset-password')}
          </Button>
          {/* <p className="forgot-password text-right">
                Login with <a href="#" onClick={(e) => this.changeLoginType(e)}>{this.state.isMobile ? 'email' : 'mobile'}</a>
            </p> */}
        </Form>
      </div>
    );
  }

  const onFinishResetPw = async (formData) => {
    if (turnstileSiteKey && _.isEmpty(turnstileToken)) {
      return message.error(t('login.complete_verification'));
    }

    const data = await Service.call('post', '/api/login/admin/forgot_password', {
      email: formData.email,
      turnstileToken,
    });

    if (!data || data.errorMessage) {
      resetTurnstile();
      return message.error(data ? data.errorMessage : t('login.login_fail'));
    }

    setResetPwModalVisible(false);
    resetTurnstile();
    message.success(t('login.reset-success'))
  }

  return (
    <Layout>
      <Layout.Content style={{ padding: '50px', backgroundColor: 'white' }}>
        <Row type="flex" justify="center">
          <Col xs={20} sm={16} md={14} lg={10} xl={8} className="pt-5 pb-3" style={{ alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: '15px' }}>
              <div>
                <img alt="" src={logo} style={{ width: '100%', maxWidth: '300px', marginBottom: '30px' }} />
              </div>
              <h2>ABA Taxi</h2>
              <h3>Admin Panel</h3>
            </div>
          </Col>
        </Row>
        <Row type="flex" justify="center" style={{ marginTop: '15px' }}>
          <Col
            xs={22}
            sm={16}
            md={14}
            lg={10}
            xl={8}
            style={{ alignItems: 'center', justifyContent: 'center' }}
          >
            {
              displayLogin()
            }
          </Col>
        </Row>
        {/* <Row type="flex" justify="center">
            <Col xs={20} sm={16} md={14} lg={10} xl={8} className="pt-5 pb-3" style={{alignItems: 'center', justifyContent: 'center'}}>
              <Link to="/company/login">Company admin login</Link>
            </Col>
          </Row> */}
      </Layout.Content>

      <Modal title={t('login.reset-password')} visible={resetPwModalVisible} onCancel={() => setResetPwModalVisible(false)} footer={null}>
        <Form onFinish={onFinishResetPw}>
          <Form.Item
            name="email"
            rules={[{ required: true, message: t('login.input_email'), type: 'email' }]}
          >
            <Input
              prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={t("common.email")}
            />
          </Form.Item>

          <Button
            style={{ width: "100%" }}
            type="primary"
            htmlType="submit"
            className="login-form-button"
            disabled={Boolean(turnstileSiteKey) && _.isEmpty(turnstileToken)}
          >
            {t('login.reset-password')}
          </Button>
        </Form>
      </Modal>
    </Layout>
  )
}

export default Login;

// function mapStateToProps(state) {
//   return {
//     app: state.app
//   };
// }

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators(ActionCreators, dispatch);
// }

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(Login);

